var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRef4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.23 17.97 46.26 17.97 9.37 52.03 9.37 36.42 29.23 17.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.81 17.97 9.37 17.97 9.37 35 27.81 17.97"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "137.72 25.31 146.4 25.31 141.61 44.76 132.93 44.76 137.72 25.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.92 44.76 114.8 44.76 116.23 38.88 120.59 44.76 130.23 44.76 123.28 34.88 134.09 25.31 124.97 25.31 118.06 31.27 119.53 25.31 111.31 25.31 106.92 44.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.49 44.76 98.29 25.31 106.97 25.31 102.17 44.76 93.49 44.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "145.74 44.76 151.75 44.76 154.54 33.66 158.06 44.76 167.77 44.76 172.63 25.31 166.22 25.31 163.49 36.03 159.73 25.31 150.58 25.31 145.74 44.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.4,44.76l4.86-19.44h13.04s8.98.71,8.04,9.81c-.03.26-.46,8.1-10.03,9.64h-15.91ZM54.57,40.23s3.73-.27,4.8-4.7c0,0,.56-3.36-.72-4.6,0,0-.84-.8-2.11-.75h-3.33l-2.4,10.04h3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.6,41.05l-2.34,3.7h-5.72l10.83-19.44h9.91l3.45,19.44h-8.65l-.66-3.7h-6.82ZM80.64,36.6l-.89-4.98-2.73,4.98h3.62Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRef4);
export default __webpack_public_path__ + "static/media/ref4.a0e3c90d31d98e38949a61d2350f6d9a.svg";
export { ForwardRef as ReactComponent };